/* Import External Modules */
import formatcoords from 'formatcoords';

/**
 * Formats GeoPoint coordinates.
 * @param {Object} coordinates - Coordinates object.
 * @param {Number} coordinates.lat - Coordinate latitude.
 * @param {Number} coordinates.lon - Coordinate longitude.
 * @param {String} options.format - Formatting options.
 */
function format(coordinates, options) {
  // Validate parameters
  if (coordinates == null || !options?.format) {
    return [];
  }

  // Get parameters
  const {
    lat,
    lon
  } = coordinates;
  const {
    format,
    decimalPlaces,
    singleLine,
    latPrefix,
    lonPrefix
  } = options;

  // Format coordinates
  const [formattedLat, formattedLon] = formatcoords(lat, lon).format(format, {
    decimalPlaces,
    latLonSeparator: '\n'
  }).split('\n');

  // Return formatted values
  const latValue = `${latPrefix != null ? latPrefix : ''} ${formattedLat}`;
  const lonValue = `${lonPrefix != null ? lonPrefix : ''} ${formattedLon}`;
  return singleLine ? [`${latValue}, ${lonValue}`] : [latValue, lonValue];
}
export default {
  format
};